import './Home.css';
import SEO from '../../components/SEO/SEO';
import Features from './Features/Features';
import Top from './Top/Top';
import NTAI from './NTAI/NTAI';
import Testimonial from './Testimonial/Testimonial';
import General from './General/General';
import Download from './Download/Download';
import Contact from './Contact/Contact';

function Home() {
    return (
        <div>
            <SEO
                title="AI-Powered Calorie Tracker"
                description="Track nutrition, and discover delicious recipes tailored to your dietary preferences and health goals."
                structuredDataType="app"
            />
            <Top />
            <Features />
            <NTAI />
            {/* <Testimonial /> */}
            <General />
            <Download />
            <Contact showSEO={false} />
        </div>
    );
}

export default Home;
